module.exports = __webpack_public_path__ + "assets/01.cc5628fb.pdf";